import styled from '@emotion/styled';

export const WrapperDiv = styled.div<{
  padding: string;
  isFlowSheetScreen: boolean;
}>`
  padding: ${({padding}) => padding};
  position: ${({isFlowSheetScreen}) =>
    isFlowSheetScreen ? 'absolute' : 'static'};
  inset: ${({isFlowSheetScreen}) => (isFlowSheetScreen ? '45%' : '0')};
`;
export const TextDiv = styled.div``;
